import { User } from 'api/types/models/user'

export enum TfaCodes {
  RequiresSetup,
  RequiresVerification,
  Disabled
}

export type LoginResponse = {
  data: {
    code: TfaCodes
    // Present only when 2FA is disabled (development): the already-authenticated user
    user?: User
  }
}